import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-36a4bcc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "creative-preview" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "toolbar__upload" }
const _hoisted_4 = {
  key: 0,
  class: "toolbar__info"
}
const _hoisted_5 = { class: "article" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "article__title" }, "Тестовая статья", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "article__paragraph" }, " В последние годы рынок цифровой рекламы продолжает активно развиваться. Бренды всё чаще ищут новые способы взаимодействия с аудиторией, экспериментируют с форматами и стремятся получить обратную связь от пользователей в момент потребления контента. Именно поэтому тестирование креативов в реальном контексте публикации становится важной частью подготовки кампании. ", -1))
const _hoisted_8 = { class: "creative-slot" }
const _hoisted_9 = ["src", "width", "height", "title"]
const _hoisted_10 = {
  key: 1,
  class: "creative-slot__placeholder"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "article__paragraph" }, " После размещения баннера между абзацами текста можно оценить, как креатив воспринимается на разных устройствах и разрешениях экрана. Обратите внимание на читаемость, удобство нажатия на элементы управления и общее впечатление от интеграции рекламного блока в поток материала. Такой подход помогает выявить проблемы до запуска кампании в продакшене. ", -1))

import { onUnmounted, ref } from "vue";

interface AdSize {
  width: number;
  height: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreativePreviewPage',
  setup(__props) {

const fileName = ref<string | null>(null);
const iframeSrc = ref<string | null>(null);
const adSize = ref<AdSize | null>(null);

function parseAdSize(html: string): AdSize {
  const match =
    html.match(
      /<meta[^>]+name=["']ad\.size["'][^>]+content=["']width=(\d+),height=(\d+)["']/i,
    ) ||
    html.match(
      /content=["']width=(\d+),height=(\d+)["'][^>]+name=["']ad\.size["']/i,
    );

  return match
    ? { width: +match[1], height: +match[2] }
    : { width: 300, height: 250 };
}

function revokeBlobUrl() {
  if (iframeSrc.value?.startsWith("blob:")) {
    URL.revokeObjectURL(iframeSrc.value);
  }
}

function clearCreative() {
  revokeBlobUrl();
  iframeSrc.value = null;
  fileName.value = null;
  adSize.value = null;
}

async function onFileChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (!file) return;

  const html = await file.text();
  revokeBlobUrl();

  iframeSrc.value = URL.createObjectURL(
    new Blob([html], { type: "text/html" }),
  );
  fileName.value = file.name;
  adSize.value = parseAdSize(html);

  input.value = "";
}

onUnmounted(() => {
  revokeBlobUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createElementVNode("input", {
          type: "file",
          accept: ".html,text/html",
          class: "toolbar__input",
          onChange: onFileChange
        }, null, 32),
        _createTextVNode(" Выбрать файл ")
      ]),
      (fileName.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(fileName.value) + " ", 1),
            (adSize.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" — " + _toDisplayString(adSize.value.width) + " × " + _toDisplayString(adSize.value.height), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (iframeSrc.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "toolbar__clear",
            onClick: clearCreative
          }, " Очистить "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("article", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (iframeSrc.value && adSize.value)
          ? (_openBlock(), _createElementBlock("iframe", {
              key: 0,
              src: iframeSrc.value,
              width: adSize.value.width,
              height: adSize.value.height,
              class: "creative-slot__iframe",
              sandbox: "allow-scripts allow-same-origin",
              title: fileName.value || 'Рекламный креатив'
            }, null, 8, _hoisted_9))
          : (_openBlock(), _createElementBlock("p", _hoisted_10, " Загрузите HTML-файл креатива (кнопка сверху) "))
      ]),
      _hoisted_11
    ])
  ]))
}
}

})